import Swal from 'sweetalert2';
import { HTTP } from './axiosConfig';
import { firestoreDB, firebase } from './firebase.js';

export default {
  methods: {
    uuid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    getCRUDName(name) {
      // Check for irregular plural ending i.e 'ies'
      if (name.slice(name.length - 3) === "ies") {
        return `${name.slice(0, name.length - 3)}y_id`;
      }
      // Remove the pluralise 's' after param name
      return `${name.slice(0, name.length - 1)}_id`;
    },
    sweetAlert(status, title, timer) {
      Swal({
        title,
        type: status,
        timer
      });
    },
    setDefaultDate(picker, dataName, data) {
      const transformDate =
        typeof data[dataName] === "number"
          ? new Date(data[dataName] * 1000)
          : new Date(data[dataName]);
      $(picker).datepicker("setDate", transformDate);
    },
    initDatePicker(data, form) {
      const my = this;
      $(() => {
        setTimeout(() => {
          $(".m_datepicker").each(function() {
            const dataName = this.getAttribute("data-name");
            $(this)
              .datepicker({
                format: "dd/mm/yyyy"
              })
              .on("changeDate", e => {
                data[dataName] = null;
                // get parameter name to update the stock value
                // Assign the UTC date to stock object for request
                if (e.date) {
                  const timeStamp = Math.round(e.date.getTime() / 1000);
                  data[dataName] = timeStamp;
                }
                form === "stockForm" ? my.getStockStatus() : null;
              });
            // Set date to editingStock date in edit mode
            if (data[dataName]) {
              my.setDefaultDate(this, dataName, data);
            }
          });
        }, 200);
      });
    },
    sendPostRequest(resource, item, callback, itemIdName) {
      HTTP.post(`api/${resource}`, item)
        .then(() => {
          // 1. Add new item to table top
          this.setNewCRUD ? this.setNewCRUD({ name: resource, item }) : null;
          this.keywords = "";
          this.inProgress = false;

          if (callback && itemIdName) {
            callback(null, item[itemIdName]);
          } else if (callback) {
            callback(null);
          }

          // Update firestore
          this.updateFirestore(resource);
        })
        .catch(err => {
          console.log("fail", err);
          const title = `${this.labels.error_updating} ${resource}`;
          this.inProgress = false;
          this.sweetAlert("error", title, 3000);
        });
    },
    toCamelCase(string) {
      return string.replace(/(\_[a-z])/g, $1 =>
        $1.toUpperCase().replace("_", "")
      );
    },
    toSnakeCase(string) {
      return string.replace(/([A-Z])/g, $1 => `_${$1.toLowerCase()}`);
    },
    alertAction(callback, label, payload) {
      const my = this;
      Swal({
        title: my.labels[label],
        showCancelButton: true,
        confirmButtonText: my.labels.proceed
      }).then(response => {
        if (response.value) {
          payload ? callback(payload) : callback();
        }
      });
    },
    logoutAction() {
      console.log("click on logout");
      HTTP.post("api/logout").catch(err => console.log(err));
      const previous = localStorage.getItem("redirectUrl");
      // Clear locaStorage
      localStorage.clear();
      this.setUserInfo(null);
      this.saveRedirectUrl(previous);
      if (this.$route.name != "Login") {
        this.$router.push("/login");
      }
    },
    saveRedirectUrl(previous) {
      const { query, name, path } = this.$route;
      const avoidSpecificRoute = (name == "Login" || name == "Home" || path == '/');
      if (!previous && avoidSpecificRoute) {
        return;
      }
      const url =
        `${path}` +
        (query && Object.keys(query).length > 0
          ? `?${this.serializeQueryUrl(query)}`
          : "");

      console.log('previous', previous, 'url', url, 'name', name)

      localStorage.setItem("redirectUrl", previous && avoidSpecificRoute ? previous : url);
    },
    serializeQueryUrl(obj) {
      var str = [];
      for (var p in obj)
        if (obj.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      return str.join("&");
    },
    createChoices(list, dataId, jsonEncode, selected, customProp) {
      const choices = [];
      this[list].map(value => {
        const data = {
          value: jsonEncode ? JSON.stringify(value) : value[dataId],
          label: value.name,
          selected: selected ? selected.indexOf(value[dataId]) !== -1 : false
        };

        if (customProp) {
          data.customProperties = {
            [customProp.name]: value[dataId]
          };
        }

        choices.push(data);
      });
      return choices;
    },
    timeoutMsg() {
      const my = this;
      setTimeout(() => {
        my.errorMessage = "";
      }, 1500);
    },
    userInputListener() {
      this.errorMessage ? (this.errorMessage = "") : null;
    },
    addNewResource(type, formValue) {
      let formData = {};
      if (type === "ingredient") {
        formData = {
          param: "ingredients",
          itemIdName: "ingredient_id",
          index: "new",
          formType: "ingredientCRUD"
        };
      } else if (type === "related_inci") {
        formData = {
          param: "related_inci",
          itemIdName: "id",
          index: "new",
          formType: "relatedINCICRUD"
        };
      } else if (type === "role") {
        formData = {
          param: "roles",
          itemIdName: "role_id",
          index: "new",
          formType: "roleCRUD"
        };
      } else if (type === "patent") {
        formData = {
          param: "patents",
          itemIdName: "patent_id",
          index: "new",
          formType: "patentCRUD"
        };
      } else if (type === "brand") {
        formData = {
          param: "brands",
          itemIdName: "brand_id",
          index: "new",
          formType: "brandCRUD"
        };
      } else if (type === "collection") {
        formData = {
          param: "collections",
          itemIdName: "collection_id",
          index: "new",
          formType: "collectionCRUD"
        };
      } else if (type === "category") {
        formData = {
          param: "categories",
          itemIdName: "category_id",
          index: "new",
          formType: "categoryCRUD"
        };
      } else if (type === "area") {
        formData = {
          param: "areas",
          itemIdName: "area_id",
          index: "new",
          formType: "areaCRUD"
        };
      } else if (type === "type_skin") {
        formData = {
          param: "type_skins",
          itemIdName: "type_skin_id",
          index: "new",
          formType: "type_skinCRUD"
        };
      } else if (type === "target") {
        formData = {
          param: "targets",
          itemIdName: "target_id",
          index: "new",
          formType: "targetCRUD"
        };
      } else if (type === "texture") {
        formData = {
          param: "textures",
          itemIdName: "texture_id",
          index: "new",
          formType: "textureCRUD"
        };
      } else if (type === "texturotheque") {
        formData = {
          param: "texturotheques",
          itemIdName: "texturotheque_id",
          index: "new",
          formType: "texturothequeCRUD"
        };
      } else if (type === "type") {
        formData = {
          param: "types",
          itemIdName: "type_id",
          index: "new",
          formType: "typeCRUD"
        };
      } else if (type === "type_pack") {
        formData = {
          param: "type_packs",
          itemIdName: "type_pack_id",
          index: "new",
          formType: "type_packCRUD"
        };
      } else if (type === "package_capacity") {
        formData = {
          param: "package_capacities",
          itemIdName: "package_capacity_id",
          index: "new",
          formType: "package_capacityCRUD"
        };
      } else if (type === "distribution_channel") {
        formData = {
          param: "distribution_channels",
          itemIdName: "distribution_channel_id",
          index: "new",
          formType: "distribution_channelCRUD"
        };
      }
      if (formValue) {
        this.$store.dispatch("products/setFormValue", formValue);
      }
      this.$store.dispatch("products/setFormModalData", formData);
      $("#modalLink").trigger("click");
    },
    convertToFloat(value) {
      const toDecimal = value.replace(",", ".");
      return toDecimal === "" ? null : parseFloat(toDecimal) || 0;
    },
    updateFirestore(resourceName, id, name, action) {
      const my = this;
      firestoreDB
        .collection(`resources_${process.env.ENV_SHORTNAME}`)
        .doc(resourceName)
        .set({
          name: resourceName,
          lastChanged: firebase.firestore.Timestamp.fromDate(new Date()),
          itemName: name || "",
          itemId: id || "",
          action: action || ""
        })
        .then(() => {
          my.$store.dispatch("setDeletedResource", null);
          console.log("updated in Firestore :)");
        })
        .catch(error => {
          console.error("Error writing document :( ", error);
        });
    },
    updateProductLeaders(product, themeId) {
      firestoreDB
        .collection(`${process.env.ENV_SHORTNAME}_productLeaders`)
        .doc(product)
        .set({
          themeId
        })
        .then(() => {
          console.log("_productLeaders updated in Firestore :)");
        })
        .catch(error => {
          console.error("Error writing document :( ", error);
        });
    },
    orderBy(dataArray, orderByKey1, orderByKey2, orderByKey3) {
      const scope = this;
      return dataArray.sort((a, b) => {
        const posA = createSortValue(orderByKey1, scope, a);
        const posB = createSortValue(orderByKey1, scope, b);

        if (orderByKey2) {
          const pos2A = createSortValue(orderByKey2, scope, a);
          const pos2B = createSortValue(orderByKey2, scope, b);

          if (orderByKey3) {
            const pos3A = createSortValue(orderByKey3, scope, a);
            const pos3B = createSortValue(orderByKey3, scope, b);

            return (
              posA.localeCompare(posB, "fr", { sensitivity: "base" }) ||
              pos2A.localeCompare(pos2B, "fr", { sensitivity: "base" }) ||
              pos3A.localeCompare(pos3B, "fr", { sensitivity: "base" })
            );
          }
          return (
            posA.localeCompare(posB, "fr", { sensitivity: "base" }) ||
            pos2A.localeCompare(pos2B, "fr", { sensitivity: "base" })
          );
        }
        return posA.localeCompare(posB, "fr", { sensitivity: "base" });
      });
    }
  },
  filters: {
    transformDecimal(value) {
      if (value !== undefined && value != null) {
        const stringed = value.toString();
        return stringed.replace(".", ",");
      }
      return "";
    }
  }
};

function createSortValue(orderByData, scope, value) {
  if (orderByData.resource) {
    return scope.getName(value[orderByData.key], orderByData.key, orderByData.resource);
  }
  return value[orderByData.key];
}



// WEBPACK FOOTER //
// ./src/assets/js/mixins.js